import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  props: {
    propsObj: Object,
  },
  data() {
    return {
      params: {
        stockId: this.propsObj.id,
      },
    };
  },
  created() {
    console.log(this);
    this.getConfigList('terminal_stock_record_list');
  },

  methods: {

  },
};
